import { apiClient, isHttpClientError } from "@/http";
import { apiRoutes } from "./apiRoutes";

/**
 * Dataset 편집 잠금(학습 사용 중)을 조회한다.
 *
 * 학습이 실행되는 동안 에피소드 visibility(전역 `excluded`)가 바뀌면 학습 입력이 바뀐다.
 * 그래서 활성 세션이 있으면 BE 가 그 write 를 거부한다. 이 엔드포인트는 **참고용 힌트**다.
 * 조회 직후에도 세션이 시작될 수 있다. 그래서 UI 는 이 값만으로 동작을 막지 않는다.
 * 저장 시점의 409 는 반드시 처리한다.
 *
 * 잠기는 write 는 `PUT /v1/datasets/{uuid}/episodes/{uuid}/review` 의 **`excluded` 변경 하나뿐**이다.
 * 품질 태그나 코멘트만 바꾸는 저장은 잠기지 않는다.
 */

export type DatasetEditLock = {
  locked: boolean;
  // 잠금을 만든 활성 학습 세션 id 목록이다. 잠기지 않았으면 빈 배열이다.
  active_session_ids: readonly string[];
};

// 잠금 상태를 조회한다(조직 멤버). training-infra 조회가 실패하면 서버는 503 을 반환한다.
// 그 경우에도 서버는 편집을 막는다(fail-closed).
export async function getDatasetEditLock(datasetUuid: string): Promise<DatasetEditLock> {
  const response = await apiClient.get<DatasetEditLock>(apiRoutes.dataset.editLock(datasetUuid));
  return response.data;
}

// 활성 학습 세션이 이 Dataset 을 쓰고 있어서 서버가 visibility 변경을 거부했다(409).
export function isTrainingLocked(error: unknown): boolean {
  return isHttpClientError(error) && error.code === "episode.training_locked";
}

// 서버가 학습 사용 여부를 확인하지 못해 변경을 거부했다(503, fail-closed).
// 사용자에게 재시도를 안내한다.
export function isTrainingCheckUnavailable(error: unknown): boolean {
  return isHttpClientError(error) && error.code === "episode.training_check_unavailable";
}
